import BaseService from "../../common/service/baseService";
import { NSApps } from "../components/types";
import { APPS_API_URL } from "../utils/constants";

export default class AppsService extends BaseService {
  async apps({
    categories,
    search,
    page = 1,
    page_size = 12,
  }: NSApps.IGetAppsParams) {
    let params: any = {
      page,
      page_size,
    };

    if (!!categories?.length) {
      params.categories = categories.join(",");
    }
    if (!!search) {
      params.search = search;
    }

    return this.get(this.buildUrl(APPS_API_URL), params);
  }

  async predict(url: string, data: {}) {
    return this.post(url, data);
  }

  async feedback(url: string, data: {}) {
    return this.post(url, data);
  }
}
